import { useAuth } from "react-oidc-context";
import { useTranslation } from "react-i18next";
import type { AvatarTypeMap } from "@mui/material";
import { Avatar } from "@mui/material";
import { Icon } from "@trimble/modus-cmx";

function ProfileAvatar({ sx, ...props }: AvatarTypeMap["props"]) {
  const auth = useAuth();
  const { t } = useTranslation();

  const { given_name, family_name, picture } = auth.user?.profile ?? {};
  const hasCustomPicture =
    picture != null && !picture.includes("default_profile.png");

  return (
    <Avatar
      {...props}
      alt={t("full_name", {
        firstName: given_name,
        lastName: family_name,
      })}
      src={hasCustomPicture ? picture : undefined}
      sx={{
        bgcolor: "transparent",
        color: "var(--modus-wc-color-neutral-content)",
        ...sx,
      }}
    >
      {!hasCustomPicture ? (
        <Icon
          name="person"
          decorative
          style={{ color: "var(--modus-wc-color-neutral-content)" }}
        />
      ) : null}
    </Avatar>
  );
}
export default ProfileAvatar;
